import React, {Component} from 'react'
import {$$} from '../../../helpers/localization'
import {CONVERTER} from '../../../utils/converter'
import PropTypes from "prop-types";

export default class BloodSugarForm extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                {this.props.blood_sugar ? $$('blood_sugar_label') : null}<br/>
                <div className="form-group">
                    <div className="input-group mb-3">
                        <input type="number" step="0.01"
                               className={this.props.errors.blood_sugar ? "custom-error form-control" : "form-control"}
                               value={this.props.blood_sugar} placeholder={$$('blood_sugar_label')}
                               name="blood_sugar" onChange={this.props.onInputChange} required/>
                        <div className="input-group-append">
                            <span className="input-group-text" style={{"height": "auto"}}
                                  id="basic-addon2">{CONVERTER.getFormattedBloodSugarUnit()}</span>
                        </div>
                    </div>
                    <div
                        className={this.props.errors.blood_sugar ? "custom-invalid-feedback" : "invalid-feedback"}>
                        {this.props.errors.blood_sugar ? $$(this.props.errors.blood_sugar) : $$('blood_sugar_required_message')}
                    </div>
                </div>
            </div>
        )
    }
}

BloodSugarForm.propTypes = {
    clearSelectedEntry: PropTypes.func,
    createEntry: PropTypes.func,
    fetchSelectedUserHealthIssues: PropTypes.func,
    formDisabled: PropTypes.object,
    getHealthIssueList: PropTypes.func,
    healthIssues: PropTypes.object,
    logbookEntries: PropTypes.array,
    medicalProfile: PropTypes.object,
    onHide: PropTypes.func,
    selectedUser: PropTypes.object,
    settings: PropTypes.object,
    show: PropTypes.bool,
    blood_sugar: PropTypes.any,
    errors: PropTypes.any,
    onInputChange: PropTypes.func,
    type: PropTypes.string,
    updateEntry: PropTypes.func,
    updateUserMedicalProfile: PropTypes.func
}